<template>
    <div>
        <div class="p-4 bg-gray-200 rounded shadow w-full mb-6 flex">
            <div>
                Von:
                <date-picker v-model="fromDate" valueType="format" format="DD.MM.YYYY" @change="fetchInvoicePayments()"></date-picker>
            </div>
            <div class="ml-2">
                Bis:
                <date-picker v-model="untilDate" valueType="format" format="DD.MM.YYYY" @change="fetchInvoicePayments()"></date-picker>
            </div>
        </div>

        <div class="flex">
          <table class="table mb-6 mr-4">
              <template v-for="item in totals">
                  <tr class="content">
                      <td>{{ item.description }}</td>
                      <td class="font-bold">{{ item.value | toCurrency }}</td>
                  </tr>
              </template>
          </table>

          <table class="table mb-6">
              <template v-for="item in kickbacks">
                  <tr class="content">
                      <td>{{ item.description }}</td>
                      <td class="font-bold">{{ item.value | toCurrency }}</td>
                  </tr>
              </template>
          </table>
        </div>

        <table class="table">
            <tr class="header">
                <th>Datum</th>
                <th>USt</th>
                <th>Brutto-Betrag</th>
                <th>Auslage</th>
                <th>Rechnung</th>
                <th>Vorgang</th>
                <th>Vermittler</th>
            </tr>
            <template v-for="invoicePayment in invoicePayments">
                <tr class="content">
                    <td>{{ invoicePayment.date | toDate }}</td>
                    <td>{{ invoicePayment.sales_tax_percent }}%</td>
                    <td class="text-right">{{ invoicePayment.amount | toCurrency }}</td>
                    <td>
                      <span v-if="invoicePayment.is_refund" class="text-sm font-medium bg-red-100 py-1 px-2 rounded text-red-500 align-middle ml-2">
                        Auslage
                      </span>
                    </td>
                    <td>
                        <a :href="invoicePayment.invoice_url" class="primary-link">
                            <i class="fas fa-receipt"></i> {{ invoicePayment.invoice_number }}
                        </a>
                    </td>
                    <td>
                        <a :href="invoicePayment.dossier_path" class="primary-link">
                            <i class="fas fa-folder-open"></i> {{ invoicePayment.dossier_human_readable }}
                        </a>
                    </td>
                    <td>
                        {{ invoicePayment.dossier_referrer_name }}
                    </td>
                </tr>
            </template>
        </table>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/locale/de';
    import moment from 'moment';

    export default {
        components: {
            DatePicker
        },
        props: [],
        data: function() {
            return {
                totals: [],
                kickbacks: [],
                invoicePayments: [],
                fromDate: null,
                untilDate: null,
            }
        },
        filters: {
            toDate: function(value, format = 'DD.MM.YYYY') {
                if (value == null) {
                    return value;
                }
                return moment(value).format(format);
            },
            toCurrency: function(value) {
                if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                });
                return formatter.format(value);
            }
        },
        methods: {
            fetchInvoicePayments: function() {
                this.$http['get']('/invoice_payments.json', {params: {
                        from_date: this.fromDate,
                        until_date: this.untilDate,
                    }}).then(response => {
                    console.log(response.body)
                    this.invoicePayments = response.body['invoice_payments']
                    this.totals = response.body['totals']
                    this.kickbacks = response.body['kickbacks']
                    this.$forceUpdate()
                }, response => {
                    console.log(response)
                })
            },
            sumPayments: function() {
                return this.invoicePayments.map(ip => ip.amount).reduce((a, b) => a + b, 0)
            },
        },
        mounted: function() {
            this.fetchInvoicePayments()
        }
    }
</script>
